<div class="grid field col-12">
  <div class="col-12 md:col-6 ui-lg-1"><label>Time Goal</label></div>
  <div class="col-12 md:col-6 ui-lg-2"><input type="number" pInputText [(ngModel)]="goals.hours" min="0"> hours</div>
  <div class="col-12 md:col-6 ui-lg-1"><label>Cost Goal</label></div>
  <div class="col-12 md:col-6 ui-lg-2">$ <input type="number" pInputText [(ngModel)]="goals.cost" min="0"></div>
</div>